//imports the svg as react components rather than loading svg files
import { ReactComponent as phone } from './phone.svg'
import { ReactComponent as print } from './icon-print.svg'
import { ReactComponent as selected } from './icon-selected.svg'

import { ReactComponent as Fuel } from './fuel.svg'
import { ReactComponent as ScheduledMaintenance } from 'icons/scheduled-maintenance.svg'
import { ReactComponent as ScheduledMaintenanceBig } from 'icons/scheduled-maintenance-big.svg'
import { ReactComponent as ScheduledMaintenance2 } from 'icons/scheduled-maintenance-2.svg'
import { ReactComponent as ReplacementTyres } from './replacement-tyres.svg'
import { ReactComponent as Incidentals } from './incidentals.svg'
import { ReactComponent as RoadsideAssistance } from './roadside-assistance.svg'
import { ReactComponent as ComprehensiveInsurance } from './ComprehensiveInsurance.svg'
import { ReactComponent as IconTick } from 'icons/comprehensive-insurance-big.svg'
import { ReactComponent as PinkTick } from 'icons/pink-tick.svg'
import { ReactComponent as OlyCross } from 'icons/cross-icon.svg'
import { ReactComponent as GreenTick } from 'icons/green-tick.svg'
import { ReactComponent as FleetDiscount } from 'icons/fleet-discount.svg'
import { ReactComponent as IconPlus } from 'icons/plus.svg'
import { ReactComponent as IconMinus } from 'icons/minus.svg'
import { ReactComponent as IconPiggy } from 'icons/Icon-moneybank.svg'
import { ReactComponent as IconMobile } from 'icons/Icon-phone.svg'
import { ReactComponent as BudgetBetter } from 'icons/budget-better.svg'
import { ReactComponent as IconFacebook } from 'icons/icon-facebook.svg'
import { ReactComponent as IconInstagram } from 'icons/icon-instagram.svg'
import { ReactComponent as IconYoutube } from 'icons/icon-youtube.svg'
import { ReactComponent as IconLinkedin } from 'icons/icon-linkedin.svg'
import { ReactComponent as BackArrow } from 'icons/back-arrow.svg'
import { ReactComponent as Sheet } from 'icons/sheet.svg'
import { ReactComponent as Flame } from 'icons/flames.svg'
import { ReactComponent as Electricity } from 'icons/Icon-electric.svg'
import { ReactComponent as ElectricityBig } from 'icons/icon-electric-big.svg'
import { ReactComponent as DropDown } from 'icons/icon-drpdwn.svg'
import { ReactComponent as WaitingDots } from 'icons/waiting_dots.svg'
import { ReactComponent as AllDone } from 'icons/all-done-tick.svg'
import { ReactComponent as BlackTick } from 'icons/black-tick.svg'
import { ReactComponent as AdobeSign } from 'icons/adobe_sign.svg'
import { ReactComponent as BluePencil } from 'icons/blue_pencil.svg'
import { ReactComponent as OlyLogo } from 'icons/Oly.svg'
import { ReactComponent as Error } from 'icons/Error.svg'
import { ReactComponent as Upload } from 'icons/upload.svg'
import { ReactComponent as Trash } from 'icons/trash.svg'
import { ReactComponent as Attachment } from 'icons/paperclip-vertical-solid.svg'
import { ReactComponent as ReLease } from 'icons/release-icon.svg'
import { ReactComponent as PayItOut } from 'icons/pay-icon.svg'
import { ReactComponent as Upgrade } from 'icons/lease-upgrade-icon.svg'
import { ReactComponent as TaxableIncome } from 'icons/oly-tax-check.svg'
import { ReactComponent as LessTax } from 'icons/less-tax.svg'
import { ReactComponent as Registration } from 'icons/registration.svg'
import { ReactComponent as Paperwork } from 'icons/paperwork.svg'
import { ReactComponent as CustomerService } from 'icons/customer-service.svg'
import { ReactComponent as EVBolt } from 'icons/ev-bolt.svg'
import React from 'react'

import styled from '@emotion/styled'

const iconsMap = {
  Attachment,
  phone,
  print,
  selected,
  Fuel,
  ScheduledMaintenance,
  ScheduledMaintenance2,
  ScheduledMaintenanceBig,
  ReplacementTyres,
  Incidentals,
  RoadsideAssistance,
  ComprehensiveInsurance,
  IconTick,
  IconPiggy,
  IconMobile,
  BudgetBetter,
  IconFacebook,
  IconInstagram,
  IconYoutube,
  IconLinkedin,
  PinkTick,
  OlyCross,
  GreenTick,
  BackArrow,
  Sheet,
  Flame,
  Electricity,
  ElectricityBig,
  DropDown,
  BluePencil,
  AdobeSign,
  AllDone,
  BlackTick,
  WaitingDots,
  OlyLogo,
  Error,
  Upload,
  Trash,
  ReLease,
  PayItOut,
  Upgrade,
  TaxableIncome,
  FleetDiscount,
  LessTax,
  Registration,
  IconPlus,
  IconMinus,
  Paperwork,
  CustomerService,
  EVBolt
}

export const Icon = (props) => {
  const iconType = props.iconType
  const size = props.size
  const primary = props.primary
  const CustomIcon = styled(iconsMap[iconType] || phone)`
    label: CustomIcon;
    height: ${size ? size * 24 + 'px' : 'auto'};
    fill: ${(props) => primary && props.theme.colors.primary};
  `

  return <CustomIcon />
}
